
import { defineComponent, nextTick, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { Mutations } from "@/store/enums/StoreEnums";
import { initializeComponents } from "@/core/plugins/keenthemes";

export default defineComponent({
  name: "app",
  setup() {
    const store = useStore();
    const theme = "theme-blue";

    onMounted(() => {
      const htmlElement = document.documentElement;
      const selectedTheme = localStorage.getItem("theme"); // TODO Should be moved to store
      if (selectedTheme) {
        htmlElement.setAttribute("theme", selectedTheme);
      } else {
        htmlElement.setAttribute("theme", theme);
        localStorage.setItem("theme", theme);
      }
      store.commit(Mutations.OVERRIDE_LAYOUT_CONFIG);
      nextTick(() => {
        initializeComponents();
      });
    });
  },
});
